import { Outlet, getRouteApi } from '@tanstack/react-router'
import { Page, PageFace } from 'ui/components/Page'
import { DocumentFooterActions } from '~bank-documents/components/DocumentFooterActions'
import { FilesSection } from '~bank-documents/components/FilesSection'
import { DocumentDetailsPage } from '~bank-documents/types/documentDetails'

import { DocumentDetailsInformation } from './components/DocumentDetailsInformation'
import { DocumentPeriods } from './components/DocumentPeriods'
import { HistorySection } from './components/HistorySection'

const DocumentDetails = () => {
  const routeApi = getRouteApi('/_app/documents/$documentId')
  const data = routeApi.useLoaderData() as DocumentDetailsPage
  const documentId = routeApi.useParams({ select: (s) => s.documentId })
  const { name, showDocumentFiles, showOneTimeDocPeriodId, showDocumentPeriods, isLastDelivery } = data

  return (
    <>
      <Outlet />
      <Page
        face={PageFace.SECONDARY}
        title="Document"
        subTitle={name}
        footerV2={
          <DocumentFooterActions
            id={data?.showOneTimeDocPeriodId}
            flags={{
              showCanAccept: data?.showCanAccept,
              showCanIncomplete: data?.showCanIncomplete,
              showCanReject: data?.showCanReject,
              showNotes: data?.showNotes,
              showNotesLabel: data?.showNotesLabel
            }}
          />
        }
      >
        <DocumentDetailsInformation />
        {showDocumentFiles && <FilesSection id={Number(showOneTimeDocPeriodId)} files={showDocumentFiles} />}
        {showDocumentPeriods && (
          <DocumentPeriods
            documentId={Number(documentId)}
            isLastDelivery={isLastDelivery}
            documentPeriods={showDocumentPeriods}
          />
        )}
        <HistorySection />
      </Page>
    </>
  )
}

export default DocumentDetails
